import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lg:!w-[35%] mdlg:!w-[40%] md:w-[70%] w-full h-auto bg-white rounded-md flex flex-col space-y-6 px-6 py-6 shadow-md" }
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Login To Your Account ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Email ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Password ")
const _hoisted_6 = { class: "w-full flex flex-row justify-end" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Forgot password? ")
const _hoisted_8 = { class: "w-full flex flex-col pt-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Log In ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_text_field = _resolveComponent("roof-text-field")!
  const _component_roof_normal_text = _resolveComponent("roof-normal-text")!
  const _component_roof_form_wrapper = _resolveComponent("roof-form-wrapper")!
  const _component_roof_button = _resolveComponent("roof-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_roof_header_text, {
        size: 'xl',
        customClass: '!font-extrabold'
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_roof_form_wrapper, {
      parentRefs: _ctx.parentRefs,
      ref: "loginFormComp",
      class: "w-full flex flex-col space-y-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_roof_text_field, {
          hasTitle: true,
          placeholder: 'Enter email address',
          padding: 'px-3 py-4',
          ref: "mail",
          rules: [_ctx.FormValidations.RequiredRule, _ctx.FormValidations.EmailRule],
          name: "Email address",
          modelValue: _ctx.signIndata.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signIndata.email) = $event)),
          customClass: 'bg-gray-100 !rounded-md'
        }, {
          title: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["rules", "modelValue"]),
        _createVNode(_component_roof_text_field, {
          hasTitle: true,
          placeholder: 'Enter password',
          padding: 'px-3 py-4',
          type: "password",
          ref: "password",
          name: "Password",
          rules: [_ctx.FormValidations.RequiredRule],
          modelValue: _ctx.signIndata.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signIndata.password) = $event)),
          customClass: 'bg-gray-100 !rounded-md'
        }, {
          title: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["rules", "modelValue"]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_roof_normal_text, {
            color: '!text-primaryDark',
            customClass: 'cursor-pointer',
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.Logic.Common.GoToRoute('/auth/forgot-password')))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["parentRefs"]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_roof_button, {
        padding: 'py-4',
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.SignIn()))
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      })
    ])
  ]))
}